import React from 'react';

const AlumniGuiding = () => {
  return (
    <div className="alumni-guiding-container" style={{ width: '100%', margin: '20px 0' }}>
      <iframe 
        src="https://wg.univariety.com/widget/2552043f-8ed5-4982-b49a-ad684f3976f6"
        title="Guiding Alumni Widget" 
        width="100%" 
        height="600px"
        loading="lazy"
        aria-label="Sanskar School, Jaipur Guiding Alumni"
        style={{ border: 'none', verticalAlign: 'top' }}
      ></iframe>
    </div>
  );
};

export default AlumniGuiding;